import { Box } from '@mantine/core';
import { useGetColor } from 'hooks';
import type { IconPropsType } from './types';

export const ShieldIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);
  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 9.07143L12 4.5L20 9.07143V9.89416C20 14.8189 16.7353 19.1471 12 20.5C7.2647 19.1471 4 14.8189 4 9.89416V9.07143Z"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};
